
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Gamepad2 } from 'lucide-react';
import GameCard from '@/components/game/GameCard';
import { Game } from '@/types/game';

interface RelatedGamesProps {
  relatedGames: Game[];
  categoryName: string;
}

const RelatedGames: React.FC<RelatedGamesProps> = ({ relatedGames, categoryName }) => {
  if (relatedGames.length === 0) {
    return null;
  }

  return (
    <Card className="border-0 bg-white/70 backdrop-blur-sm shadow-lg">
      <CardHeader>
        <CardTitle className="flex items-center text-xl md:text-2xl">
          <Gamepad2 className="w-5 h-5 md:w-6 md:h-6 mr-3 text-blue-600" />
          More {categoryName} Games
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
          {relatedGames.map((relatedGame) => (
            <GameCard 
              key={relatedGame.id} 
              game={relatedGame} 
              size="small"
            />
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default RelatedGames;
